export interface CategoryBanner {
  image: string;
  alt: string;
}

const CATEGORY_BANNER_IMAGES: Record<string, { image: string; label: string }> = {
  kobieta: {
    image: "/images/home/kobieta.png",
    label: "Kobieta",
  },
  mezczyzna: {
    image: "/images/home/mezczyzna.png",
    label: "Mężczyzna",
  },
  lifestyle: {
    image: "/images/home/lifestyle.png",
    label: "Dom i Ogród",
  },
  dzieci: {
    image: "/images/home/dzieci.png",
    label: "Dzieci",
  },
};

export function useBanners() {
  const brand = useBrand();
  // Zwykły boolean, nie ref — patrz useCatalogOnly.
  const { sellingEnabled } = useCatalogOnly();

  function getCategoryBanner(slug: string): CategoryBanner {
    // Mapa wyżej i zapasowe `hero.png` to fotografie lavmaga/youlooka
    // (modelki). Sklep katalogowy dostawał je na KAŻDEJ stronie kategorii,
    // bo żaden jego dział nie pasuje do kluczy mapy — „Elektronika" leciała
    // prosto do zapasowego zdjęcia kobiety. Klientka proles chce działów bez
    // zdjęć, z ikonami w turkusie, więc pusty obraz: strona kategorii
    // renderuje wtedy wariant z ikoną działu.
    if (!sellingEnabled) {
      return { image: "", alt: "" };
    }

    // Marka z własnym zdjęciem banera (discanto) — mapa i `hero.png` lavmaga
    // są dla niej fotografiami cudzego sklepu. Pusty łańcuch = wariant bez
    // zdjęcia. Bez pola: dotychczasowe zachowanie (lavmag, youlook).
    if (brand.categoryBanner !== undefined) {
      return { image: brand.categoryBanner, alt: slug };
    }

    const normalized = slug
      .toLowerCase()
      .replace(/ę/g, "e")
      .replace(/ź/g, "z")
      .replace(/ą/g, "a");
    const entry = CATEGORY_BANNER_IMAGES[normalized] ?? CATEGORY_BANNER_IMAGES[slug];
    if (entry) {
      return { image: entry.image, alt: `${entry.label} – ${brand.name}` };
    }
    return { image: "/images/home/hero.png", alt: slug };
  }

  return {
    getCategoryBanner,
  };
}
